(function () {
  // P is the class prefix: '' in the HTML preview, 'lpg-' in the Shopify build,
  // where every class is prefixed so the theme's own .hero/.btn/.sticky can't collide.
  var P = 'lpg-';
  var d = document, html = d.documentElement;
  var c = function (name) { return P + name; };
  var root = d.querySelector('.' + c('lp')) || d;
  var q = function (sel) { return root.querySelector(sel); };
  var qa = function (sel) { return root.querySelectorAll(sel); };

  // ?static: no entrance animation (used for screenshots)
  if (/[?&]static\b/.test(location.search)) html.classList.add(c('static'));

  // preview only: highlight every claim or image that still needs checking
  var KEY = 'lp-show-verify', vb = d.getElementById('pv-verify');
  function setVerify(on) {
    html.classList.toggle(c('show-verify'), on);
    if (vb) vb.setAttribute('aria-pressed', on ? 'true' : 'false');
    try { localStorage.setItem(KEY, on ? '1' : '0'); } catch (e) {}
  }
  if (vb) {
    try { if (localStorage.getItem(KEY) === '1' || /[?&]verify\b/.test(location.search)) setVerify(true); } catch (e) {}
    vb.addEventListener('click', function () { setVerify(!html.classList.contains(c('show-verify'))); });
    var cnt = d.getElementById('pv-count');
    if (cnt) cnt.textContent = d.querySelectorAll('[data-verify]').length;
  }

  // reviews: phones show four, the rest behind "Show more"
  var rgrid = q('.' + c('rgrid')), rmore = q('.' + c('rmore'));
  if (rgrid && rmore) {
    if (rgrid.children.length > 4) rmore.classList.add(c('has-more'));
    rmore.addEventListener('click', function () { rgrid.classList.add(c('is-open')); rmore.classList.remove(c('has-more')); });
  }

  // everyday-photos strip: arrow buttons on desktop, native swipe on phones
  var track = q('.' + c('gallery__track'));
  if (track) {
    var navs = qa('.' + c('gnav'));
    var syncNav = function () {
      var max = track.scrollWidth - track.clientWidth - 2;
      navs.forEach(function (b) {
        b.disabled = b.getAttribute('data-dir') === '-1' ? track.scrollLeft <= 2 : track.scrollLeft >= max;
      });
    };
    navs.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.querySelector('.' + c('gcard')), step = card ? card.offsetWidth + 14 : 300;
        track.scrollBy({ left: Number(b.getAttribute('data-dir')) * step * 2, behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);
    syncNav();
  }

  if (!('IntersectionObserver' in window)) {
    qa('[data-reveal]').forEach(function (el) { el.classList.add(c('in')); });
    return;
  }

  // gentle fade-up as sections arrive
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add(c('in')); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  qa('[data-reveal]').forEach(function (el) { io.observe(el); });

  // phones: the routine's background takes the colour of the step in view
  var rt = q('.' + c('routine')), narrow = matchMedia('(max-width: 959px)');
  if (rt) {
    var sio = new IntersectionObserver(function (entries) {
      if (!narrow.matches) return;
      entries.forEach(function (e) {
        if (e.isIntersecting) rt.style.setProperty('--rt-bg', e.target.getAttribute('data-tint'));
      });
    }, { rootMargin: '-45% 0px -45% 0px' });
    rt.querySelectorAll('.' + c('step')).forEach(function (s) { sio.observe(s); });
  }

  // phones: sticky "get all four" bar, only once the routine offer has been scrolled past,
  // and hidden again at the final choice (which has the same button)
  var bar = q('.' + c('sticky')), offerCtas = q('.' + c('offer__ctas')), fin = q('.' + c('final'));
  if (bar && offerCtas && fin) {
    var passed = false, atFinal = false;
    var update = function () { bar.classList.toggle(c('is-on'), passed && !atFinal); };
    new IntersectionObserver(function (es) {
      passed = !es[0].isIntersecting && es[0].boundingClientRect.top < 0; update();
    }).observe(offerCtas);
    new IntersectionObserver(function (es) { atFinal = es[0].isIntersecting; update(); }).observe(fin);
  }
})();
